// Psi Circuit ability — wraps legacy circuit charge/release.

import { registerAbility } from '../abilities';
import { G } from '../state';
import { SND_CircuitRelease } from '../../audio/index';

const tr = Math.trunc;

let releaseCircuitFn: (() => void) | null = null;

export function setPsiCircuitRelease(fn: () => void): void {
  releaseCircuitFn = fn;
}

export function chargePsiCircuit(): void {
  if (G.magic_circuit >= 0) {
    G.magic_circuit += tr((G.circuit_fillrate * (3 + G.training + (G.circuit_fillrate === 30 ? 1 : 0))) / 3);
    if (G.magic_circuit > G.circuit_size) G.magic_circuit = G.circuit_size;
  }
}

export function recoverPsiCircuit(): void {
  if (G.magic_circuit < 0) {
    G.magic_circuit += tr((G.circuit_recoverrate * (3 + G.training + (G.circuit_recoverrate === 30 ? 1 : 0))) / 3);
    if (G.magic_circuit > 0) G.magic_circuit = 0;
  }
}

export function firePsiCircuit(): void {
  if (releaseCircuitFn) {
    releaseCircuitFn();
    return;
  }
  G.circuit_release = 1;
  G.release_range = G.circuit_range;
  G.release_x = G.player_x;
  G.release_y = G.player_y;
  G.release_str = G.magic_circuit;
  if (G.circuit_fillrate === 30) G.release_str = tr(G.release_str * 1.25);
  SND_CircuitRelease(G.release_str);
  G.magic_circuit *= -1;
}

registerAbility({
  id: 'psi-circuit',
  name: 'Psi Circuit',
  cooldownMs: 0,
  isUnlocked: () => true,
});

export { firePsiCircuit as psiCircuitRelease };
